import { takeEvery, call } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { astSlice, astApi } from 'Pages/pp'

function* sendProcurementPlan() {
	try {
		yield* call(astApi.sendProcurementPlan)
		yield* call(notifyMessageCreator, 'common.procurement_plan_request.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const astSaga = function* saga() {
	yield* takeEvery(astSlice.actions.sendProcurementPlan.type, sendProcurementPlan)
}
